import { SearchConsoleAnalyticsSearchAppearancesDimension } from '@/modules/DomainsApi';
import { FC } from 'react';

interface Props {
  value: SearchConsoleAnalyticsSearchAppearancesDimension['key'];
}

export const SearchAppearancesLabel: FC<Props> = ({ value }) => {
  return (
    <span>{ value }</span>
  );
};
